import { accountDetails } from "@frameworks/web/di";
import { EQTOCIgnoreList } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
export const LoginClientDataMapper = async (data) => {
    var _a;
    if (data.accs.rstusr && !data.accs.rstpwd) {
        data.accs.rstpwd = true;
        data.cnsntLst.push({ name: "rstpwd", accType: data.accTyp, mdtry: true });
    }
    let clientLoginDataEntity = {
        jwtToken: localStorage.getItem("jwt_token"),
        cnsntLst: data.cnsntLst,
        accData: getAccData(data),
        accTyp: data.accTyp,
        userID: data.accs.uid,
        emaildId: data.accs.eml,
        empOrDependent: (_a = data === null || data === void 0 ? void 0 : data.accs) === null || _a === void 0 ? void 0 : _a.empOrDependent,
        accountCode: data.accTyp == "CO" ? data.accs.coAccID : data.accs.eqAccID,
        lgnSrc: await accountDetails.getLoginSrc(),
        isImpersonated: await accountDetails.getCipFlag(),
    };
    return clientLoginDataEntity;
};
const getAccData = (data) => {
    var _a;
    let accData = {
        accType: data.accTyp,
        accs: data.accs,
        userId: data.accs.uid,
        excs: data.excs,
        ordTypes: data.ordTypes.filter((y) => {
            return !(EQTOCIgnoreList === null || EQTOCIgnoreList === void 0 ? void 0 : EQTOCIgnoreList.includes(y.value));
        }),
        prds: manageProductesData(data.prds, data.productsAlias),
        val: data.val,
        mrgSts: data.mrgSts,
        mtf: (_a = data.mtf) === null || _a === void 0 ? void 0 : _a.sts,
        adhrEQ: {
            stat: data === null || data === void 0 ? void 0 : data.adhrEQ,
            brkCode: data.accs.eqBrkCode,
        },
        adhrCOM: {
            stat: data === null || data === void 0 ? void 0 : data.adhrCOM,
            brkCode: data.accs.coBrk,
        },
        opCnst: data.optCnsts,
        coAccID: data.accs.coAccID,
        eqAccID: data.accs.eqAccID,
        eqRmRt: data.accs.eqRmRt,
        eqAccName: data.accs.eqAccName,
        coAccName: data.accs.coAccName,
        dfPrdsMTF: data.dfPrdsMTF,
    };
    return accData;
};
const manageProductesData = (productes, productsAlias) => {
    let result = productes.map((product) => {
        return Object.assign(Object.assign({}, product), { prd: product.prd.map((prod) => {
                let x = productsAlias.find((x) => x.key === prod.prdVal);
                return Object.assign(Object.assign({}, prod), { prdVal: x === null || x === void 0 ? void 0 : x.value, mainVal: x === null || x === void 0 ? void 0 : x.key });
            }) });
    });
    return result;
};
